import { getStore } from '../store/store';
import { getSelectedCalendarsOrDefault as getSelectedCalendarsOrDefaultFromStore } from 'owa-selected-calendars-loader';
import { getUserMailboxInfo } from 'owa-client-ids';
import { ObservableMap } from 'mobx';

export function getTimePanelSelectedCalendarIdsMap(): ObservableMap<string, string[]> {
    const selectedCalendars = getStore().calendarIds;

    if (selectedCalendars && selectedCalendars.length != 0) {
        let selectedCalendarsMap = new ObservableMap<string, string[]>();
        selectedCalendarsMap.set(getUserMailboxInfo().primarySmtpAddress, selectedCalendars);

        return selectedCalendarsMap;
    } else {
        // if time panel selected calendars have not been set, fall back to showing the calendar modules selected calendars
        return getCalendarModuleSelectedCalendars();
    }
}

export function getCalendarModuleSelectedCalendars(): ObservableMap<string, string[]> {
    return getSelectedCalendarsOrDefaultFromStore();
}
